module.exports = __webpack_public_path__ + "static/media/no-connection.342fe741.png";